import { createContext, useContext, useEffect, useState } from 'react';
import { ServerFlags } from '../../src/types/flags';
import { useSocket } from './socket';
import { ClientRequests } from '../../src/enum/socket';

const ServerFlagsContext = createContext<ServerFlags>(null);

export function ServerFlagsProvider({ children }) {
    const { socket } = useSocket();
    const [serverFlags, setServerFlags] = useState<ServerFlags>(null);

    useEffect(
        () => {
            if (!socket) {
                return;
            }

            let isActive = true;

            const fetchServerFlags = async (): Promise<void> => {
                try {
                    const newServerFlags = await socket.emitWithAck(
                        ClientRequests.GetServerFlags,
                    );

                    if (isActive) {
                        setServerFlags(newServerFlags);
                    }
                } catch (err) {
                    console.error('Error fetching server flags', err);
                }
            };

            void fetchServerFlags();

            return () => {
                isActive = false;
            };
        },
        [socket],
    );

    return (
        <ServerFlagsContext.Provider value={serverFlags}>
            {children}
        </ServerFlagsContext.Provider>
    );
}

export function useServerFlags() {
    return useContext(ServerFlagsContext);
}
